/**
 * The published-services read behind the home page's cards and the catalogue,
 * as one set of query options.
 *
 * usePublicServices reads it on those pages, and App starts it as it loads, on
 * a hard load of either (src/pages/public/publicRoutePreload.ts). The two must
 * share the key, the fetcher and the staleTime exactly, or the page would read
 * it a second time instead of finding it in the cache. That is why it is its own
 * module: App's entry chunk carries it, without the hooks beside it.
 */

import { queryOptions } from "@tanstack/react-query";
import { queryKeys } from "@/lib/query-client";
import { getServices, type ServiceWithMeta } from "@/services/serviceService";

export function publicServicesQuery() {
  return queryOptions<ServiceWithMeta[], Error>({
    queryKey: [...queryKeys.services.all, "public", "catalogue"],
    queryFn: async () => {
      const { data, error } = await getServices();
      if (error) throw error;
      return data || [];
    },
    staleTime: 2 * 60 * 1000, // Services don't change frequently
  });
}
